import axios from 'axios';
import * as Config from '../../config';

const state = {
    pleasures: {},
}

const actions = {

    loadPleasures({commit, dispatch}) {
        commit('LOAD_PLEASURES_CATEGORY_USER')

        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'pleasure/all')
                .then(
                    response => {
                        commit('LOAD_PLEASURES_CATEGORY_USER_OK')
                        resolve(response.data.data)

                    })
                .catch(error => {
                    commit('LOAD_PLEASURES_CATEGORY_USER_FAIL')
                    reject(error)
                })
        })
    },
    userPleasuresSave({commit, dispatch}, form) {
        commit('LOAD_PLEASURES_CATEGORY_USER')

        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'userpleasure/save', form)
                .then(
                    response => {
                        commit('LOAD_PLEASURES_CATEGORY_USER_OK')
                        resolve(response.data)

                    })
                .catch(error => {
                    commit('LOAD_PLEASURES_CATEGORY_USER_FAIL')
                    reject(error)
                })
        })
    },
    categoryPleasuresSave({commit, dispatch}, form) {
        commit('LOAD_PLEASURES_CATEGORY_USER')

        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'categorypleasure/save', form)
                .then(
                    response => {
                        commit('LOAD_PLEASURES_CATEGORY_USER_OK')
                        resolve(response.data)

                    })
                .catch((error) => {
                    console.log(error);
                    commit('LOAD_PLEASURES_CATEGORY_USER_FAIL');
                    reject();
                })
        })
    },

}

const mutations = {}

export default {
    state,
    actions,
    mutations
}
